import { render, staticRenderFns } from "./switchableInput.vue?vue&type=template&id=b49cc4ea&scoped=true&"
import script from "./switchableInput.vue?vue&type=script&lang=js&"
export * from "./switchableInput.vue?vue&type=script&lang=js&"
import style0 from "./switchableInput.vue?vue&type=style&index=0&id=b49cc4ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49cc4ea",
  null
  
)

export default component.exports